export default __webpack_public_path__ + "static/media/economic.df496f2d.svg";